import { Box, Button, Grid, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FC } from 'react';

const BENEFITS = [
	'One workflow for EAS IOSS Delivery and higher-value DDP orders',
	'No separate monthly DDP plan fee for EAS IOSS customers',
	'No minimum monthly shipment volume',
	'0% customs duty when qualifying UK origin rules are met',
	'Up to 90% import VAT recovery on returned DDP orders',
	'Customers receive their orders without border payments',
];

export const NoEuDdpBanner: FC = () => {
	return (
		<Box sx={{ display: 'flex', justifyContent: 'center' }}>
			<Paper
				sx={{
					margin: '0px 20px 20px 20px',
					padding: '10px 20px 0 20px',
					overflowX: 'auto',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					gap: 1,
					backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
					borderRadius: '12px',
					p: '20px',
					maxWidth: '1200px',
				}}
			>
				<Grid container spacing={2}>
					<Grid item xs={12} lg={7}>
						<Typography
							component="p"
							color="secondary"
							sx={{
								fontSize: '.9rem',
								fontWeight: 'bold',
								textTransform: 'uppercase',
								letterSpacing: '.05em',
								mb: 1,
							}}
						>
							EAS DDP is now available for UK to EU delivery
						</Typography>
						<Typography
							variant="h2"
							color="primary"
							sx={{
								fontSize: '1.6rem',
								fontWeight: 'bold',
								mb: 2,
							}}
						>
							Sell to the EU with one EAS delivery workflow
						</Typography>
						<Typography
							component="p"
							color="text.primary"
							sx={{
								fontSize: '1rem',
								mb: 2,
							}}
						>
							EAS DDP gives UK sellers a simpler way to manage EU deliveries across all order
							values.
						</Typography>
						<Typography
							component="p"
							color="text.primary"
							sx={{
								fontSize: '1rem',
								mb: 2,
							}}
						>
							EAS IOSS Delivery is used for eligible orders, while higher-value orders use EAS DDP.
							Taxes, duties and delivery charges are handled through EAS, so your customers receive
							their orders without separate border payments.
						</Typography>
						<Typography
							component="p"
							color="text.secondary"
							sx={{
								fontSize: '.95rem',
								fontStyle: 'italic',
								mb: 2,
							}}
						>
							Available now for shipments from the UK to all EU countries. More origin countries
							will be added soon.
						</Typography>
						<Typography
							variant="h2"
							color="primary"
							sx={{
								fontSize: '1.3rem',
								fontWeight: 'bold',
								mt: 2,
								mb: 1,
							}}
						>
							Why activate EAS DDP?
						</Typography>
						<List
							sx={{
								m: '0 0 0 20px',
								p: 0,
								listStyleType: 'disc',
								'& .MuiListItem-root': {
									display: 'list-item',
									padding: 0,
								},
								'& .MuiListItem-root + .MuiListItem-root': {
									marginTop: 0.5,
								},
								'& .MuiTypography-root': {
									color: 'text.primary',
									fontSize: '1rem',
								},
							}}
						>
							{BENEFITS.map((benefit) => (
								<ListItem key={benefit}>
									<ListItemText primary={benefit} />
								</ListItem>
							))}
						</List>
					</Grid>
					<Grid
						item
						xs={12}
						lg={5}
						sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
					>
						<img
							src="/img/eu-ddp-banner.webp"
							alt="EAS DDP delivery from the UK to the EU"
							style={{
								width: '100%',
								height: 'auto',
								borderRadius: '12px',
							}}
						/>
					</Grid>
				</Grid>

				<Grid
					container
					spacing={1}
					sx={{
						mt: 2,
						width: '100%',
					}}
				>
					<Grid item xs={12} lg={4}>
						<Button
							variant="contained"
							color="primary"
							href="https://form.jotform.com/261933134749362"
							target="_blank"
							fullWidth
						>
							Request activation
						</Button>
					</Grid>
					<Grid item xs={12} lg={4}>
						<Button
							variant="outlined"
							color="primary"
							href="https://easproject.com/postal-ddp/"
							target="_blank"
							fullWidth
						>
							View pricing and details
						</Button>
					</Grid>
					<Grid item xs={12} lg={4}>
						<Button
							variant="outlined"
							color="primary"
							href="https://easproject.com/schedule-a-meeting-with-eas/"
							target="_blank"
							fullWidth
						>
							Book a meeting
						</Button>
					</Grid>
				</Grid>

				<Typography
					component="p"
					color="text.secondary"
					sx={{
						fontSize: '.85rem',
						mt: 2,
					}}
				>
					EAS DDP must be activated separately. Submit the activation request to enable it for your
					account.
				</Typography>
			</Paper>
		</Box>
	);
};
